import _ from 'lodash';
import styles from './barStyles.module.scss';
import { ElementType, FC, useMemo } from 'react';
import { Resolver, useEditor } from '@craftjs/core';
import { Layers } from '@craftjs/layers';
import { PanelContainer } from './components/panelContainer';
import { ControlsGroup } from './components/controlsGroup';
import { ControlSelectorItem } from './components/controlSelectorItem';
import { BufferPanel } from './bufferPanel/bufferPanel';
import { useTranslation } from 'react-i18next';
import { SelectorGroupEnum, SelectorResolverType } from 'src/features/generalForms/builder/generalFormBuilder.t';

export const LeftBar: FC<{
  selectors: SelectorResolverType<Resolver>;
  layerItem: ElementType<any> | undefined;
}> = ({ selectors, layerItem }) => {
  const { t } = useTranslation('dev');
  const { query } = useEditor();

  const groupedSelectors = useMemo(
    () =>
      _.groupBy(
        Object.entries(selectors)
          .filter(([, value]) => value.group !== SelectorGroupEnum.None)
          .map(([key, value]) => ({ key: key, ...value })),
        (item) => item.group,
      ),
    [selectors],
  );

  return (
    <div className={styles.toolboxContainer}>
      <PanelContainer variant={'flex'} header={'Form fields'} expanded={true}>
        {Object.entries(groupedSelectors).map(([key, value]) => (
          <ControlsGroup
            header={t(
              `StudySettingsPage.FormBuilder.ControlsGroupEnum.${SelectorGroupEnum[+key]}`,
              SelectorGroupEnum[+key],
            )}
            key={key}
          >
            {value?.map((selector) => (
              <ControlSelectorItem
                {...selector}
                key={selector.name}
                component={query.parseReactElement(selector.userComponent).toNodeTree()}
              />
            ))}
          </ControlsGroup>
        ))}
      </PanelContainer>

      <PanelContainer variant={'flex'} header={'Layers'} expanded={false}>
        <Layers expandRootOnLoad={true} renderLayer={layerItem} />
      </PanelContainer>

      <PanelContainer variant={'flex'} header={'Buffer'} expanded={false}>
        <BufferPanel selectors={selectors} />
      </PanelContainer>
    </div>
  );
};
